function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelectAPartner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 184 152",
    style: {
      enableBackground: "new 0 0 184 152"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#F8F7F7"
    },
    cx: 91.8,
    cy: 138.6,
    rx: 67.8,
    ry: 12.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AEB8C3"
    },
    d: "M141.7,110.5c-0.8-2-1.8-3.8-3-5.5c-6-8.9-15.3-14.7-25.7-16.2c-1.3-0.1-2.7,0.1-3.8,0.9 c-4.8,3.6-10.5,5.6-16.4,6.1c-0.8,0.1-1.6,0.1-2.4,0.1c-0.8,0-1.6,0-2.4-0.1c-5.9-0.4-11.6-2.5-16.4-6.1c-1-0.8-2.5-1.2-3.8-0.9 C57.4,90.2,48,96.1,42.1,105c-1.2,1.7-2.2,3.6-3,5.5c-0.4,0.8-0.3,1.7,0.1,2.5c1,1.8,2.3,3.6,3.5,5.2c1.8,2.5,3.8,4.7,6,6.8 c1.8,1.8,3.9,3.5,6,5.2c10.3,7.7,22.7,11.7,35.5,11.7c12.8,0,25.2-4.1,35.5-11.7c2.1-1.6,4.2-3.4,6-5.2c2.1-2.1,4.2-4.3,6-6.8 c1.3-1.7,2.5-3.4,3.5-5.2C141.9,112.2,142,111.2,141.7,110.5z M90.4,26.8c-16.4,0-29.9,13.4-29.9,29.9s13.4,29.9,29.9,29.9 c16.4,0,29.9-13.4,29.9-29.9S106.8,26.8,90.4,26.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M98,130.8c-2.4,6-7.7,8.7-7.7,8.7s-5.2-2.7-7.7-8.7c-1.8-4.6,2.4-23.5,5.3-35c0.8,0.1,1.6,0.1,2.4,0.1 c0.8,0,1.6,0,2.4-0.1C95.6,107.3,99.9,126.2,98,130.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#DCE0E6",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M90.4,51.2c6.1,0,7.6,2.2,7.6,2.2"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#DCE0E6",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    cx: 106.9,
    cy: 53.4,
    r: 8.9
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#DCE0E6",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M115.9,53.4c1.8-8.7,3.1-7.2,3.1-7.2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#DCE0E6",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M90.4,51.2c-6.1,0-7.6,2.2-7.6,2.2"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#DCE0E6",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    cx: 73.8,
    cy: 53.4,
    r: 8.9
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#DCE0E6",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M64.8,53.4c-1.8-8.7-3.1-7.2-3.1-7.2"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#DCE0E6"
    },
    cx: 136.5,
    cy: 121.7,
    r: 16.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 129,
    y1: 121.7,
    x2: 144,
    y2: 121.7
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 136.5,
    y1: 129.2,
    x2: 136.5,
    y2: 114.2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectAPartner);
export default __webpack_public_path__ + "static/media/SelectAPartner.dea7d141.svg";
export { ForwardRef as ReactComponent };